import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventName: "Mathrubhumi Event",
  ringSizerGiven: "",
  voucherGiven: "",
  name: "",
  contactNumber: "",
  gender: "",
  ageGroup: "",
  lookingFor: [],
  budget: [],
  occasion: "",
  occasionOther: "",
  knowAbout: "",
  knowAboutOther: "",
  timeSpent: "",
  reason: "",
};

const feedbackFormSlice = createSlice({
  name: "feedbackForm",
  initialState,
  reducers: {
    updateField(state, action) {
      const { field, value } = action.payload;
      state[field] = value;
      localStorage.setItem("feedbackForm", JSON.stringify(state));
    },
    resetForm(state) {
      Object.assign(state, initialState);
      localStorage.removeItem("feedbackForm");
    },
  },
});

export const { updateField, resetForm } = feedbackFormSlice.actions;
export default feedbackFormSlice.reducer;
